import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable()
export class HttpLogInterceptor implements HttpInterceptor {
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			map((event: any) => {
				if (event instanceof HttpResponse) {
					/* gestione della response */
					console.debug(`${request.method} - `, request.url);
					if (request.method === 'POST') {
						console.debug('BODY: ', request.body);
					}
					console.debug('RES: ', event.body);
				}
				return event;
			}),
		);
	}
}
